module.exports = __webpack_public_path__ + "media/new_message.8102b02f.ogg";